import { json } from "@codemirror/lang-json";
import { Box } from "@mui/material";
import CodeMirror, { ViewUpdate } from "@uiw/react-codemirror";
import React, { useEffect, useState } from "react";
import { Dialog } from "../../../framework/Dialog/Dialog";
import { DialogButtons } from "../../../framework/Dialog/DialogButtons";
import { Translations } from "ui/Scripts/source/models/translations";

interface ITaskTypeDialogSchemaDialogProps {
    dataSchema: string;
    onSave: (value: string) => void;
    onClose: () => void;
}

export const TaskTypeDialogSchemaDialog = (props: ITaskTypeDialogSchemaDialogProps) => {
    const [schema, setSchema] = useState<string>();

    useEffect(() => {
        setSchema(props.dataSchema);
    }, [props.dataSchema]);
    
    const handleChangeSchema = (value: string, _viewUpdate: ViewUpdate) => {
        setSchema(value);
    };

    return (
        <Dialog
            id="task-form-designer-schema-dialog"
            maxWidth="md"
            title={Translations.Schema}
            body={
                <CodeMirror
                    value={schema}
                    height={"calc(100vh - 210px)"}
                    extensions={[json()]}
                    onChange={handleChangeSchema}
                    style={{
                        border: "1px solid BEBEBE",
                        borderRadius: "4px"
                    }}
                />
            }
            actions={
                <Box display="flex" justifyContent="flex-end" width="100%">
                    <DialogButtons
                        saveTitle={Translations.OK}
                        onCancel={props.onClose}
                        onSave={async () => props.onSave(schema)}
                    />
                </Box>
            }
            onClose={props.onClose}
        />
    );
};
